<template>
  <div class="container-fluid">
    <b-card no-body class="card-transparent-background mt-4 mb-2">
      <b-card-header class="py-0 pl-0"
        ><b-card-body class="py-2">
          <b-card-title class="card-title-doorder my-3"
            >Route Optimization Map
          </b-card-title>
        </b-card-body>
      </b-card-header>
    </b-card>

    <b-card no-body class="card-transparent-background mt-0">
      <b-card-body class="p-0">
        <b-row>
          <b-col xl="9" md="8">
            <GmapMap
              :center="map_center"
              :zoom="11"
              map-type-id="terrain"
              class="order-map-routes-container-doorder"
              ref="gmap"
              :options="map_options"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in route_drivers_markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                :icon="marker_img_driver"
                @click="openInfoWindowTemplateDriver(index)"
              />
              <GmapMarker
                :key="'d' + index"
                v-for="(m, index) in route_last_markers"
                :position="m.position"
                :clickable="false"
                :draggable="false"
                :icon="marker_img_dropoff"
              />
              <GmapMarker
                :key="'m' + index"
                v-for="(m, index) in route_markers"
                :position="m.position"
                :clickable="false"
                :draggable="false"
                :icon="m.img"
                :label="m.label"
              />
              <gmap-info-window
                :options="{
                  maxWidth: 300,
                  pixelOffset: { width: 0, height: -25 },
                }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
              >
                <div v-html="infoWindow.template"></div>
              </gmap-info-window>
              <!-- <DirectionsRenderer
                v-for="(route, index) in drivers_routes"
                :key="index + 1"
                travelMode="DRIVING"
                :origin="route.origin"
                :destination="route.destination"
                :waypoints="route.waypoints"
                :route_color="routes_colors[index % drivers_routes.length]"
              /> -->
            </GmapMap>
          </b-col>
          <b-col xl="3" md="4">
            <b-card no-body class="m-0">
              <b-card-body class="p-0">
                <div
                  class="accordion drivers-routes-accordion-doorder"
                  role="tablist"
                >
                  <b-card
                    v-for="(route, index) in map_routes"
                    :key="index"
                    class="driver-routes-map-card-doorder"
                    no-body
                  >
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <p
                        v-b-toggle="'accordion-' + (index + 1)"
                        class="driver-route-title-collapse"
                      >
                        {{ route[0].deliverer_name }}
                      </p>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + (index + 1)"
                      accordion="accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text> {{ route[0].coordinates }}</b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-5">
          <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
            <b-button
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder mb-1 w-100 nextbutton"
              >Next</b-button
            >
          </b-col>
          <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
            <b-button
              type="button"
              variant="doorder-danger-outline"
              class="btn-bumblebee btn-doorder w-100 mb-1"
              v-b-modal.delete-order-modal-doorder
              >Delete</b-button
            >
          </b-col>
        </b-row>
        <!-- <div class="text-muted">Current Tab: {{ tabIndex }}</div> -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import { getOrderStatusClassAndStr } from "@/utils/helper-functions-doorder.js";
import DatePicker from "vue2-datepicker";

import { gmapApi } from "vue2-google-maps";
var greyScaleStyle = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#f5f5f5",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#dadada",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5",
      },
    ],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c9c9c9",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
];
// import DirectionsRenderer from "./DirectionsRenderer";

export default {
  name: "DoorderRouteMap",
  components: {},
  data() {
    return {
      client_name: "DOORDER",
      google: gmapApi,

      user_title: null,

      overlay_show: false,
      map_center: { lat: 30.57930296436947, lng: 31.49377648591158 },

      map_options: {
        styles: greyScaleStyle,
      },

      map_routes: [
        [
          {
            coordinates: "30.57930296436947,31.49377648591158",
            deliverer_id: "120",
            deliverer_name: "Shurooq Maghraby",
            deliverer_first_letter: "SM",
          },
          {
            ETA: 6,
            coordinates: "30.583876,31.504539",
            order_id: "1450",
            type: "pickup",
          },
          {
            ETA: 17,
            coordinates: "30.54389,31.5276",
            order_id: "1459",
            type: "pickup",
          },
          {
            ETA: 0,
            coordinates: "30.54389,31.52760",
            order_id: "1459",
            type: "dropoff",
          },
          {
            ETA: 78,
            coordinates: "30.02064,31.43427",
            order_id: "1461",
            type: "pickup",
          },
          {
            ETA: 0,
            coordinates: "30.02064,31.43427",
            order_id: "1457",
            type: "pickup",
          },
          {
            ETA: 0,
            coordinates: "30.02064,31.43427",
            order_id: "1454",
            type: "pickup",
          },
          {
            ETA: 15,
            coordinates: "30.02744,31.40750",
            order_id: "1457",
            type: "dropoff",
          },
          {
            ETA: 0,
            coordinates: "30.02744,31.40750",
            order_id: "1454",
            type: "dropoff",
          },
          {
            ETA: 0,
            coordinates: "30.02744,31.4075",
            order_id: "1460",
            type: "pickup",
          },
          {
            ETA: 21,
            coordinates: "30.11190,31.39625",
            order_id: "1460",
            type: "dropoff",
          },
          {
            ETA: 16,
            coordinates: "30.08072,31.36496",
            order_id: "1450",
            type: "dropoff",
          },
          {
            ETA: 30,
            coordinates: "30.04442,31.23571",
            order_id: "1458",
            type: "pickup",
          },
          {
            ETA: 0,
            coordinates: "30.04442,31.23571",
            order_id: "1461",
            type: "dropoff",
          },
          {
            ETA: 35,
            coordinates: "30.02064,31.43427",
            order_id: "1458",
            type: "dropoff",
          },
        ],
        [
          {
            coordinates: "30.04810528092501,31.4008745700002",
            deliverer_id: "121",
            deliverer_name: "Soad Elbhnasy",
            deliverer_first_letter: "SE",
          },
          {
            ETA: 281,
            coordinates: "28.094541,30.759174",
            order_id: "1452",
            type: "pickup",
          },
          {
            ETA: 220,
            coordinates: "30.02744,31.40750",
            order_id: "1452",
            type: "dropoff",
          },
        ],
        [
          {
            coordinates: "30.0480925,31.4009406",
            deliverer_id: "125",
            deliverer_name: "Youssef Mohamed",
            deliverer_first_letter: "YM",
          },
        ],
      ],
      drivers_routes: [],
      marker_img_driver: {
        url: require("@/assets/images/doorder/map-pin-driver.png"),
        scaledSize: { width: 40, height: 40 },
      },

      marker_img_pickup: {
        url: require("@/assets/images/doorder/map-pin-pickup.png"),
        scaledSize: { width: 40, height: 40 },
      },
      marker_img_dropoff: {
        url: require("@/assets/images/doorder/map-pin-customer.png"),
        scaledSize: { width: 40, height: 40 },
      },
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      circle_map_radius: 10,
      drawCircle: false,

      drivers_list: [],

      directionsService: null,
      directionsRenderer: null,
      routes_colors: [
        "#4C97A1",
        "#f5a505",
        "#656565",
        "#FF8C00",
        "#30BB30",
        "#60A244",
        "#56BDA3",
        "#CC4B4C",
        "#F56D6D",
        "#E8CA49",
        "#D2B431",
        "#FF9F43",
      ],

      route_drivers_markers: [],
      route_last_markers: [],
      route_markers: [],
    };
  },
  beforeMount() {},
  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    this.user_title = user.title;
    let temp = this;
    setTimeout(function () {
      temp.drawRoutes();
    }, 1000);
  },
  watch: {},

  methods: {
    getOrderStatusClassAndStr,
    openInfoWindowTemplateDriver(index) {
      const location = this.route_drivers_markers[index];
      // console.log(location);
      this.infoWindow.position = location.position;
      this.infoWindow.template = `<p class="mapNameP">${location.driver_name}</p>`;
      this.infoWindow.open = true;
    },
    drawRoutes() {
      console.log("======");
      console.log(this.google);
      console.log(this.google.maps);
      // console.log(new google)

      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new window.google.maps.DirectionsRenderer();

      console.log("display routes");
      for (let i = 0; i < this.map_routes.length; i++) {
        console.log(this.map_routes[i]);
        var routeTemp = this.map_routes[i];
        if (routeTemp.length > 1) {
          var waypoints = [];
          var destination;
          for (var j = 1; j < routeTemp.length; j++) {
            //                 			console.log(routeOpt[j])
            //                 			console.log("point "+j +" "+routeTemp[j]['coordinates'])
            if (j == routeTemp.length - 1) {
              destination = new google.maps.LatLng(
                routeTemp[j]["coordinates"].split(",")[0],
                routeTemp[j]["coordinates"].split(",")[1]
              );
            } else {
              waypoints.push({
                location: new google.maps.LatLng(
                  routeTemp[j]["coordinates"].split(",")[0],
                  routeTemp[j]["coordinates"].split(",")[1]
                ),
                stopover: true,
              });
            }
          }
          //                 		console.log(waypoints)
          let route = {
            origin: new google.maps.LatLng(
              routeTemp[0]["coordinates"].split(",")[0],
              routeTemp[0]["coordinates"].split(",")[1]
            ),
            destination: destination,
            waypoints: waypoints,
            travelMode: google.maps.TravelMode.DRIVING,
          };
          this.drivers_routes.push(route);
          console.log(routeTemp[0].deliverer_name);
          console.log(routeTemp[0].deliverer_id);
          console.log(routeTemp[0].deliverer_first_letter);
          this.calculateAndDrawDriverRoute(
            i,
            route,
            routeTemp[0].deliverer_name,
            routeTemp[0].deliverer_id,
            routeTemp[0].deliverer_first_letter
          );
        }
        console.log(this.drivers_routes);
      }
    },
    calculateAndDrawDriverRoute(
      index,
      route,
      driver_name,
      driver_id,
      driver_first_letter
    ) {
      console.log("in calculate and draw driver draw");
      console.log(route);
      console.log(driver_id, driver_name, driver_first_letter);

      let temp = this;

      this.directionsService.route(route, function (result, status) {
        var polylines = new google.maps.Polyline({
          path: [],
        });
        console.log(result);
        console.log(status);
        console.log(temp.routes_colors);
        console.log("=========================================");
        // temp.directionsRenderer.setOptions({
        //   map: temp.$refs.gmap,
        //           polylineOptions: {
        //               strokeColor: temp.routes_colors[index % temp.routes_colors.length],
        //               strokeOpacity: 0.5,
        //               strokeWeight: 6,
        //               zindex: 10000,
        //               clickable: true
        //           },
        //           suppressMarkers: true
        //       })

        var leg = result.routes[0].legs[0];
        // makeMarker(leg.start_location, markerDriver, "title",  driver_name, driver_first_letters, null);
        temp.route_drivers_markers.push({
          position: leg.start_location,
          driver_name: driver_name,
          driver_id: driver_id,
          driver_first_letter: driver_first_letter,
        });
        leg = result.routes[0].legs[result.routes[0].legs.length - 1];
        // makeMarker(leg.end_location, markerAddress, 'title', map, null, null, routeTemp[result.routes[0]
        // 	.legs.length]['order_id']);
        temp.route_last_markers.push({
          position: leg.end_location,
        });

        //////
        let opacityChangeStep =
          (0.8 - 0.2) / (result.routes[0].legs.length - 1);

        let imgMarker = {
          path: "M 0,0 c -2,-20 -10,-22 -10,-30 a 10,10 0 1 1 20,0 c 0,8 -8,10 -10,30 z",
          fillColor: temp.routes_colors[index % temp.routes_colors.length],
          fillOpacity: 1,
          strokeColor: "#fff",
          strokeWeight: 1,
          scale: 1.12,
          labelOrigin: new google.maps.Point(0, -29),
          size: new google.maps.Size(40, 50),
        };

        for (var i = 0; i < result.routes[0].legs.length; i++) {
          //console.log(leg.start_location.lat()+","+leg.start_location.lng())
          //console.log(routeTemp[i+1]['type'])

          leg = result.routes[0].legs[i];

          //console.log(routeTemp[i+1]['order_id'])
          //                        		if(routeTemp[i+1]['type']==='pickup'){
          //                       			makeMarker(leg.end_location, markerPickup, "title", map,driver_name,null,routeTemp[i+1]['order_id']);
          //                       		}
          //                       		else if(routeTemp[i+1]['type']==='dropoff'){
          //                       			makeMarker(leg.end_location, markerAddress, "title", map,driver_name,null,routeTemp[i+1]['order_id']);
          //                       		}

          // makeMarkerForRoute(
          //   leg.end_location,
          //   color_index,
          //   driver_name,
          //   routeTemp[i + 1]["order_id"],
          //   i + 2
          // );
          console.log(i, temp.map_routes[index][i + 1]);
          console.log("---------", temp.map_routes[index][i + 1]);
          temp.route_markers.push({
            position: leg.end_location,
            driver_name: driver_name,
            order_number: temp.map_routes[index][i + 1].order_id,
            order_type: temp.map_routes[index][i + 1].type,
            img: imgMarker,
            label: {
              text: "" + (i + 2),
              color: "#fff",
              fontSize: "12px",
              fontWeight: "500",
            },
          });
        }
        console.log(">>>>>>>>>>>>>>>>>>>.");
        console.log(temp.route_markers);
      });
    },
    makeMarker(
      position,
      marker,
      title,
      driver_name,
      driver_first_letters,
      order_number
    ) {},
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/doorder/orders/route_optimization/RouteMap.vue